(function() {
  function cascadeLatas(section) {
    var infos = section.querySelectorAll('.latas-info');
    infos.forEach(function(info, infoIdx) {
      var baseDelay = infoIdx === 0 ? 500 : 900;
      var kids = info.children;
      for (var i = 0; i < kids.length; i++) {
        kids[i].style.animationDelay = (baseDelay + i * 100) + 'ms';
      }
    });
    section.classList.add('intro-fired');
  }

  function cascadeFaq(section) {
    var items = section.querySelectorAll('.faq-item');
    items.forEach(function(item, i) {
      item.style.animationDelay = (400 + i * 75) + 'ms';
    });
    section.classList.add('intro-fired');
  }

  function fireIntro(section) {
    if (section.classList.contains('latas-section')) {
      cascadeLatas(section);
    } else if (section.classList.contains('faq-section')) {
      cascadeFaq(section);
    } else {
      section.classList.add('intro-fired');
    }
  }

  function startObserver() {
    var sections = document.querySelectorAll('.latas-section, .about-section, .contact-section, .faq-section');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(fireIntro);
      return;
    }

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          fireIntro(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });

    sections.forEach(function(s) { io.observe(s); });
  }

  function waitForGate() {
    var gate = document.getElementById('age-gate');
    var gateVisible = gate && gate.style.display !== 'none' && getComputedStyle(gate).display !== 'none';
    if (!gateVisible) {
      startObserver();
      return;
    }
    // Gate still up — wait for it to clear, then start observing
    var started = false;
    function go() {
      if (started) return;
      started = true;
      startObserver();
    }
    window.addEventListener('mamitas:age-gate-cleared', go, { once: true });
    // Safety: if event never fires, fall back after 6s
    setTimeout(go, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForGate);
  } else {
    waitForGate();
  }
})();
